import React, { lazy, useState, useEffect, Suspense } from 'react'
import { Layout } from 'components'
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Row,
  Container
} from 'reactstrap'
import { useParams, useLocation, useNavigate } from 'react-router-dom'

const PartnerAdjustmentTree = lazy(() => import('pages/Partner/PartnerAdjustment/PartnerAdjustmentTree')) 

function Partner (props) {
  const { search, pathname } = useLocation()
  const location = useLocation()
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState('partnerAdjustment')

  const toggleTab = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab)
      navigate(`${pathname}?tab=${tab}`)
    }
  }

  useEffect(() => {
    const tabParam = new URLSearchParams(search).get('tab')
    const initialTab = tabParam || 'partnerAdjustment'
    setActiveTab(initialTab)
  }, [location])
  return (
    <Layout>
      <Container className='page-content' fluid style={{ padding: 30 }}>
        <Row>
          <Nav tabs>
            <NavItem>
              <NavLink
                className={activeTab === 'partnerAdjustment' ? 'sub-link active' : ''}
                onClick={() => toggleTab('partnerAdjustment')}
              >
                파트너 카+슬 통합 정산
              </NavLink>
            </NavItem>
          </Nav>
        </Row>
        <Row>
          <TabContent className='partner-tab-content' activeTab={activeTab}>
            {activeTab === 'partnerAdjustment' && (
              <TabPane tabId='partnerAdjustment'>
                <Suspense fallback={<div>Loading...</div>}>
                  <PartnerAdjustmentTree />
                </Suspense>
              </TabPane>
            )}
          </TabContent>
        </Row>
      </Container>
    </Layout>
  )
}

export default Partner
